import Vue from 'vue';
import VueSanitize from 'vue-sanitize';

Vue.use(VueSanitize, {
  allowedTags: ['span', 'br', 'a'],
  allowedAttributes: { span: ['class'], a: ['href', 'target'] },
});
